export const LoginFailed = "Login Failed ...";
export const IncompleteLoginForm = "Your Details Are Incomplete To Being Validated By Server, Please Fill Details Properly !";
export const LoggingInWait = "Your Login Credentials Are Being Validated At Server, It May Take A While !";